export default __webpack_public_path__ + "static/media/Google_Maps_Logo_2020.af2371f5.svg";